<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="姓名">
              <a-input v-model="queryParam.name" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" v-action:add>
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="avatar" slot-scope="text">
        <a-avatar v-if="text" :src="text" size="small" />
        <a-avatar v-else icon="user" size="small" />
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" v-action:edit>编辑</a>
          <a-divider type="vertical" />
          <a @click="handleShareLink(record)" v-action:edit>分享链接</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a v-action:delete>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>

    <create-form
      v-if="visible"
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <share-link-form
      v-if="shareLinkVisible"
      ref="shareLinkModal"
      :visible="shareLinkVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleShareLinkCancel"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { card_list, card_create, card_delete } from '@/api/business_card'
import CreateForm from '../modules/CardCreateForm'
import ShareLinkForm from '../modules/ShareLinkForm'

export default {
  name: 'CardList',
  components: {
    STable,
    CreateForm,
    ShareLinkForm
  },
  data () {
    return {
      pageNum: 1,
      loading: false,
      confirmLoading: false,
      visible: false,
      shareLinkVisible: false,
      mdl: {},
      queryParam: {},
      columns: [
        {
          title: '序号',
          width: '60px',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          width: '70px',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '姓名',
          dataIndex: 'name',
          width: '100px'
        },
        {
          title: '公司',
          dataIndex: 'company',
          width: '200px',
          ellipsis: true
        },
        {
          title: '职位',
          dataIndex: 'position',
          width: '120px',
          ellipsis: true
        },
        {
          title: '手机',
          dataIndex: 'phone',
          width: '130px'
        },
        {
          title: '操作',
          width: '180px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: parameter => {
        return card_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      }
    }
  },
  methods: {
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields()
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    handleShareLink (record) {
      this.mdl = record
      this.shareLinkVisible = true
    },
    handleShareLinkCancel () {
      this.shareLinkVisible = false
    },
    handleDelete (record) {
      card_delete(record.id).then(() => {
        this.$message.success('删除成功')
        this.$refs.table.refresh()
      })
    },
    handleOk () {
      const createModal = this.$refs.createModal
      const form = createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          // 添加头像URL - 从组件实例获取
          if (createModal.avatarUrl) {
            values.avatar = createModal.avatarUrl
          }
          card_create(values).then(() => {
            this.visible = false
            this.confirmLoading = false
            form.resetFields()
            this.$refs.table.refresh()
          }).catch(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
